import Joyride, { STATUS, ACTIONS } from 'react-joyride';
import React from 'react';
import { theme } from '../../../App/MuiTheme';
import GeneralSettingsJoyrideContent from './content/GeneralSettingsJoyrideContent';
import VideoPreviewJoyrideContent from './content/VideoPreviewJoyrideContent';
import PlaybackControlsJoyrideContent from './content/PlaybackControlsJoyrideContent';
import AdditionalSettingsJoyrideContent from './content/AdditionalSettingsJoyrideContent';
import SaveAndExportJoyrideContent from './content/SaveAndExportJoyrideContent';

class SettingsPanelSection extends React.Component {
    state = {
        steps: [
            {
                target: '#preview-display-container',
                disableBeacon: true,
                placement: 'left',
                title: 'Video Preview',
                content: <VideoPreviewJoyrideContent />
            },
            {
                target: '#playback-controls-container',
                placement: 'top',
                title: 'Preview Playback Controls',
                content: <PlaybackControlsJoyrideContent />
            },
            {
                target: '#general-panel-section',
                placement: 'right',
                title: 'General Settings',
                content: <GeneralSettingsJoyrideContent />,
            },
            {
                target: '#setting-panel-buttons-container',
                placement: 'right',
                title: 'Additional Settings',
                content: <AdditionalSettingsJoyrideContent />
            },
            {
                target: '#file-controls-container',
                placement: 'bottom',
                title: 'Save & Export',
                content: <SaveAndExportJoyrideContent />
            },
        ]
    }

    render() {
        const { classes, onFinished, ...other } = this.props;
        const { steps } = this.state;

        return (
            <Joyride
                steps={steps}
                {...other}
                continuous
                disableCloseOnEsc
                disableOverlayClose
                styles={{
                    options: {
                        primaryColor: theme.palette.primary.dark,
                        borderRadius: theme.shape.borderRadius,
                    }
                }}
                locale={{
                    back: 'BACK',
                    close: 'CLOSE',
                    last: 'FINISH',
                    next: 'NEXT',
                    skip: 'EXIT'
                }}
                callback={data => {
                    if (data.status === STATUS.FINISHED || data.action === ACTIONS.CLOSE) {
                        setTimeout(() => {
                            if (typeof onFinished === 'function') onFinished();
                        }, 10);
                    }
                }}
            />
        );
    }
}

export default SettingsPanelSection;
